export default __webpack_public_path__ + "static/media/header.079c1f50.jpg";